import gql from 'graphql-tag';

import type {
  ApplicationAttachmentsQuery,
  ApplicationAttachmentsQueryVariables,
} from 'src/App/AppPageBlock/graphql/hirer-types.generated';

import graphqlClient from './client';

export const query = gql`
  query ApplicationAttachments($input: ApplicationAttachmentInput!) {
    applicationAttachments(input: $input) {
      nodes {
        typeName
        filename
        uploadedDate
        isPdf
        id
        type
        uploadedUser
      }
    }
  }
`;

export const fetchApplicationAttachments = async (prospectId: string) => {
  const { data } = await graphqlClient.query<
    ApplicationAttachmentsQuery,
    ApplicationAttachmentsQueryVariables
  >({
    variables: {
      input: { prospectId },
    },
    query,
  });
  if (data === null) {
    throw new Error('error in rendering attachments');
  }
  return data.applicationAttachments?.nodes || [];
};
